import React, { FC, ReactElement } from 'react'

export const DashboardAddReportIcon: FC = (): ReactElement => (
    <svg version='1.1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
        <path d='M1.2,8.3h14.4v14.4H1.2V8.3z' fill='none' />
        <path
            fill='currentColor'
            d='M3,16.1h4.8v-6H3V16.1z M3,20.9h4.8v-3.6H3V20.9z M9,20.9h4.8v-6H9V20.9z M9,10.1v3.6h4.8v-3.6H9z'
        />
        <rect fill='currentColor' x='17.1' y='2' width='3' height='7' />
        <rect
            fill='currentColor'
            x='17.1'
            y='2'
            transform='matrix(4.486906e-11 -1 1 4.486906e-11 13.1017 24.1018)'
            width='3'
            height='7'
        />
    </svg>
)
